import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";

export default function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const API_BASE = process.env.REACT_APP_API_BASE_URL;

  const [user, setUser] = useState(null);
  const [sidebarInfo, setSidebarInfo] = useState({
    possess_amt: 0,
    upper_count: 0,
  });

  /* =========================
   * 1️⃣ 로그인 유저 (localStorage)
   * ========================= */
  useEffect(() => {
    const stored = localStorage.getItem("first");
    if (stored) {
      setUser(JSON.parse(stored));
    }
  }, []);

  /* =========================
   * 2️⃣ Sidebar 정보 API 호출
   * ========================= */
  useEffect(() => {
    const fetchSidebarInfo = async () => {
      const token = localStorage.getItem("token");
      if (!token) return;
      const res = await axios.get(`${API_BASE}/api/sidebar/info`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setSidebarInfo(res.data);
    };

    fetchSidebarInfo();
  }, []);
  if (!user) return <div>로딩 중...</div>;
  return (
    <div
      className="nk-sidebar nk-sidebar-fixed is-theme"
      data-content="sidebarMenu"
    >
      <div className="nk-sidebar-element nk-sidebar-head">
        <div className="nk-menu-trigger">
          <a
            href="#"
            onClick={() => navigate("/")}
            className="nk-nav-toggle nk-quick-nav-icon d-xl-none"
            data-target="sidebarMenu"
          >
            <em className="icon ni ni-arrow-left"></em>
          </a>
          <a
            href="#"
            onClick={() => navigate("/")}
            className="nk-nav-compact nk-quick-nav-icon d-none d-xl-inline-flex"
            data-target="sidebarMenu"
          >
            <em className="icon ni ni-menu"></em>
          </a>
        </div>
        <div className="nk-sidebar-brand">
          <a
            href="#"
            onClick={() => navigate("/")}
            className="logo-link nk-sidebar-logo"
          >
            <img
              className="logo-light logo-img"
              src="/images/logo_matrix.png"
              srcSet="/images/logo_matrix_3x.png 3x"
              alt="logo"
            />
            <img
              className="logo-dark logo-img logo-img-lg"
              src="/images/logo_matrix-dark.png"
              srcSet="/images/logo_matrix-dark3x.png 3x"
              alt="logo-dark"
            />
          </a>
        </div>
      </div>

      <div
        className="lead-text allcash"
        style={{ display: "flex", alignItems: "center" }}
      >
        <div style={{ display: "flex", flexDirection: "column" }}>
          <div
            style={{ display: "flex", alignItems: "center", marginBottom: 5 }}
          >
            <em className="icon">
              <img src="/images/icons/icon-coin-c1.png" alt="coin" />
            </em>
            <span className="cash_total">
              <span>{parseInt(sidebarInfo.possess_amt).toLocaleString()}</span>
            </span>
          </div>
        </div>
        <div
          id="menuSpain"
          className="btn text-info"
          style={{ marginLeft: "auto" }}
        >
          <i className="fas fa-redo"></i>
        </div>
      </div>

      <div className="nk-sidebar-element nk-sidebar-body">
        <div className="nk-sidebar-content">
          <div className="nk-sidebar-menu" data-simplebar>
            <ul className="nk-menu">
              <li
                className={`nk-menu-item ${
                  location.pathname === "/" ? "active" : ""
                }`}
              >
                <a
                  href="#"
                  onClick={() => navigate("/")}
                  className="nk-menu-link"
                >
                  <span className="nk-menu-icon">
                    <em className="icon ni ni-tablet"></em>
                  </span>
                  <span className="nk-menu-text">Dashboard</span>
                </a>
              </li>
              {user.user_id === "root" ?(<>
              <li className="nk-menu-heading">
                <h6 className="overline-title text-primary-alt">루트 전용 메뉴</h6>
              </li>

              {/* <li
                className={`nk-menu-item ${
                  location.pathname === "/users" ? "active" : ""
                }`}
              >
                <a
                  href="#"
                  onClick={() => navigate("/users")}
                  className="nk-menu-link"
                >
                  <span className="nk-menu-icon">
                    <em className="icon ni ni-setting"></em>
                  </span>
                  <span className="nk-menu-text">벤더사 점검</span>
                </a>
              </li> */}
              <li
                className={`nk-menu-item ${
                  location.pathname === "/NewGame" ? "active" : ""
                }`}
              >
                <a
                  href="#"
                  onClick={() => navigate("/NewGame")}
                  className="nk-menu-link"
                >
                  <span className="nk-menu-icon">
                    <em className="icon ni ni-list-thumb"></em>
                  </span>
                  <span className="nk-menu-text">신규게임 목록</span>
                </a>
              </li>

              <li
                className={`nk-menu-item ${
                  location.pathname === "/NoKor" ? "active" : ""
                }`}
              >
                <a
                  href="#"
                  onClick={() => navigate("/NoKor")}
                  className="nk-menu-link"
                >
                  <span className="nk-menu-icon">
                    <em className="icon ni ni-alert-circle"></em>
                  </span>
                  <span className="nk-menu-text">한글 누락 리스트</span>
                </a>
              </li>
              </>
              ): null}

              <li className="nk-menu-heading">
                <h6 className="overline-title text-primary-alt">통합관리</h6>
              </li>
              <li
                className={`nk-menu-item ${
                  location.pathname === "/users" ? "active" : ""
                }`}
              >
                <a
                  href="#"
                  onClick={() => navigate("/users")}
                  className="nk-menu-link"
                >
                  <span className="nk-menu-icon">
                    <em className="icon ni ni-user"></em>
                  </span>
                  <span className="nk-menu-text">회원관리</span>
                  <span className="nk-menu-badge">
                    {" "}
                    {(sidebarInfo?.upper_count || 0).toLocaleString()}
                  </span>
                </a>
              </li>

              <li
                className={`nk-menu-item ${
                  location.pathname === "/agents" ? "active" : ""
                }`}
              >
                <a
                  href="#"
                  onClick={() => navigate("/agents")}
                  className="nk-menu-link"
                >
                  <span className="nk-menu-icon">
                    <em className="icon ni ni-user-fill"></em>
                  </span>
                  <span className="nk-menu-text">에이전트관리</span>
                </a>
              </li>

              {/* {userClassInt > 0 ? (
                <>
                  <li
                    className={`nk-menu-item ${
                      location.pathname === "/AgentsReg" ? "active" : ""
                    }`}
                  >
                    <a
                      href="#"
                      onClick={() => navigate("/AgentsReg")}
                      className="nk-menu-link"
                    >
                      <span className="nk-menu-icon">
                        <em className="icon ni ni-user-fill"></em>
                      </span>
                      <span className="nk-menu-text">에이전트 승인관리</span>
                    </a>
                  </li>
                </>
              ) : null} */}
              <li className="nk-menu-heading">
                <h6 className="overline-title text-primary-alt">거래관리</h6>
              </li>
              <li
                className={`nk-menu-item ${
                  location.pathname === "/trxsAll" ? "active" : ""
                }`}
              >
                <a
                  href="#"
                  onClick={() => navigate("/trxsAll")}
                  className="nk-menu-link"
                >
                  <span className="nk-menu-icon">
                    <em className="icon ni ni-coin"></em>
                  </span>
                  <span className="nk-menu-text">전체거래</span>
                </a>
              </li>
              <li
                className={`nk-menu-item ${
                  location.pathname === "/MyMoney" ? "active" : ""
                }`}
              >
                <a
                  href="#"
                  onClick={() => navigate("/MyMoney")}
                  className="nk-menu-link"
                >
                  <span className="nk-menu-icon">
                    <em className="icon ni ni-coins"></em>
                  </span>
                  <span className="nk-menu-text">나의머니</span>
                </a>
              </li>
              <li
                className={`nk-menu-item ${
                  location.pathname === "/TransferOther" ? "active" : ""
                }`}
              >
                <a
                  href="#"
                  onClick={() => navigate("/TransferOther")}
                  className="nk-menu-link"
                >
                  <span className="nk-menu-icon">
                    <em className="icon ni ni-coins"></em>
                  </span>
                  <span className="nk-menu-text">에이전트 거래내역</span>
                </a>
              </li>

              <li className="nk-menu-heading">
                <h6 className="overline-title text-primary-alt">관리</h6>
              </li>
              <li
                className={`nk-menu-item ${
                  location.pathname === "/Vendors" ? "active" : ""
                }`}
              >
                <a
                  href="#"
                  onClick={() => navigate("/Vendors")}
                  className="nk-menu-link"
                >
                  <span className="nk-menu-icon">
                    <em className="icon ni ni-activity-round-fill"></em>
                  </span>
                  <span className="nk-menu-text">벤더관리/한도제한</span>
                </a>
              </li>

              <li
                className={`nk-menu-item ${
                  location.pathname === "/Gamelimit" ? "active" : ""
                }`}
              >
                <a
                  href="#"
                  onClick={() => navigate("/Gamelimit")}
                  className="nk-menu-link"
                >
                  <span className="nk-menu-icon">
                    <em className="icon ni ni-opt-dot"></em>
                  </span>
                  <span className="nk-menu-text">최대 당첨금액 설정</span>
                </a>
              </li>

              <li
                className={`nk-menu-item ${
                  location.pathname === "/exchangeDayList" ? "active" : ""
                }`}
              >
                <a
                  href="#"
                  onClick={() => navigate("/exchangeDayList")}
                  className="nk-menu-link"
                >
                  <span className="nk-menu-icon">
                    <em className="icon ni ni-activity-round-fill"></em>
                  </span>
                  <span className="nk-menu-text">환율정보</span>
                </a>
              </li>

              <li className="nk-menu-heading">
                <h6 className="overline-title text-primary-alt">보고서</h6>
              </li>

              {/* <li
                className={`nk-menu-item ${
                  location.pathname === "/ReportPartner" ? "active" : ""
                }`}
              >
                <a
                  href="#"
                  onClick={() => navigate("/ReportPartner")}
                  className="nk-menu-link"
                >
                  <span className="nk-menu-icon">
                    <em className="icon ni ni-swap-alt"></em>
                  </span>
                  <span className="nk-menu-text">에이전트 지급/회수</span>
                </a>
              </li> */}

              <li
                className={`nk-menu-item ${
                  location.pathname === "/DailyAD" ? "active" : ""
                }`}
              >
                <a
                  href="#"
                  onClick={() => navigate("/DailyAD")}
                  className="nk-menu-link"
                >
                  <span className="nk-menu-icon">
                    <em className="icon ni ni-calendar-alt-fill"></em>
                  </span>
                  <span className="nk-menu-text">일별정산</span>
                </a>
              </li>
              <li
                className={`nk-menu-item ${
                  location.pathname === "/DailyAM" ? "active" : ""
                }`}
              >
                <a
                  href="#"
                  onClick={() => navigate("/DailyAM")}
                  className="nk-menu-link"
                >
                  <span className="nk-menu-icon">
                    <em className="icon ni ni-calendar-booking-fill"></em>
                  </span>
                  <span className="nk-menu-text">월별정산</span>
                </a>
              </li>
              <li
                className={`nk-menu-item ${
                  location.pathname === "/LogsSend" ? "active" : ""
                }`}
              >
                <a
                  href="#"
                  onClick={() => navigate("/LogsSend")}
                  className="nk-menu-link"
                >
                  <span className="nk-menu-icon">
                    <em className="icon ni ni-calendar-booking-fill"></em>
                  </span>
                  <span className="nk-menu-text">실패로그</span>
                </a>
              </li>
              <li
                className={`nk-menu-item ${
                  location.pathname === "/LimitChangeLogs" ? "active" : ""
                }`}
              >
                <a
                  href="#"
                  onClick={() => navigate("/LimitChangeLogs")}
                  className="nk-menu-link"
                >
                  <span className="nk-menu-icon">
                    <em className="icon ni ni-calendar-booking-fill"></em>
                  </span>
                  <span className="nk-menu-text">제한변경 로그</span>
                </a>
              </li>
              <li
                className={`nk-menu-item ${
                  location.pathname === "/loginLog" ? "active" : ""
                }`}
              >
                <a
                  href="#"
                  onClick={() => navigate("/loginLog")}
                  className="nk-menu-link"
                >
                  <span className="nk-menu-icon">
                    <em className="icon ni ni-box"></em>
                  </span>
                  <span className="nk-menu-text">로그인 로그</span>
                </a>
              </li>

              <li
                className={`nk-menu-item ${
                  location.pathname === "/GameLimitList" ? "active" : ""
                }`}
              >
                <a
                  href="#"
                  onClick={() => navigate("/GameLimitList")}
                  className="nk-menu-link"
                >
                  <span className="nk-menu-icon">
                    <em className="icon ni ni-tags"></em>
                  </span>
                  <span className="nk-menu-text">당첨한도 초과 회수 기록</span>
                </a>
              </li>

              <li className="nk-menu-heading">
                <h6 className="overline-title text-primary-alt">
                  공지/환경설정
                </h6>
              </li>
              <li
                className={`nk-menu-item ${
                  location.pathname === "/Notice" ? "active" : ""
                }`}
              >
                <a
                  href="#"
                  onClick={() => navigate("/Notice")}
                  className="nk-menu-link"
                >
                  <span className="nk-menu-icon">
                    <em className="icon ni ni-notice"></em>
                  </span>
                  <span className="nk-menu-text">공지사항</span>
                </a>
              </li>
              <li
                className={`nk-menu-item ${
                  location.pathname === "/NoticeUpdate" ? "active" : ""
                }`}
              >
                <a
                  href="#"
                  onClick={() => navigate("/NoticeUpdate")}
                  className="nk-menu-link"
                >
                  <span className="nk-menu-icon">
                    <em className="icon ni ni-notice"></em>
                  </span>
                  <span className="nk-menu-text">업데이트</span>
                </a>
              </li>

              <li className="nk-menu-heading">
                <h6 className="overline-title text-primary-alt">API 문서</h6>
              </li>
              {/* <li className={`nk-menu-item ${location.pathname === '/ApiDoc' ? 'active' : ''}`}>
                                <a href="#" onClick={() => navigate('/ApiDoc')} className="nk-menu-link">
                                    <span className="nk-menu-icon"><em className="icon ni ni-file-docs"></em></span>
                                    <span className="nk-menu-text">API 소개</span>
                                </a>
                            </li>
                            
                           <li className={`nk-menu-item ${location.pathname === '/ApiCommon' ? 'active' : ''}`}>
                                <a href="#" onClick={() => navigate('/ApiCommon')} className="nk-menu-link">
                                    <span className="nk-menu-icon"><em className="icon ni ni-file-docs"></em></span>
                                    <span className="nk-menu-text">공통 API</span>
                                </a>
                            </li> */}
              <li className="nk-menu-item">
                <a
                  href="https://documenter.getpostman.com/view/30854370/2sB2qi7cj5"
                  className="nk-menu-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="nk-menu-icon">
                    <em className="icon ni ni-file-docs"></em>
                  </span>
                  <span className="nk-menu-text">API 통합문서</span>
                </a>
              </li>
              {/* <li className="nk-menu-item">
                                <a href="html/api/data.html" className="nk-menu-link">
                                    <span className="nk-menu-icon"><em className="icon ni ni-file-docs"></em></span>
                                    <span className="nk-menu-text">데이터 API</span>
                                </a>
                            </li> */}
              {/* <li className="nk-menu-item">
                                <a href="html/api/appendix.html" className="nk-menu-link">
                                    <span className="nk-menu-icon"><em className="icon ni ni-file-docs"></em></span>
                                    <span className="nk-menu-text">부록</span>
                                </a>
                            </li> */}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
